<template>
    <component :is="componentTag" />
  </template>
  <script>
  import webBatteryIndustry from "./web";
  import mobileIndustry from "./mobile";
  export default {
    components: {
      webBatteryIndustry,
      mobileIndustry,
    },
    data() {
      return {
        isMobile: false,
        componentTag: "",
      };
    },
    created() {
      this.listenObserverWidth(750);
    },
    methods: {
      // 监听可视窗口宽度
      listenObserverWidth(mobileWidth) {
        const resizeObserver = new ResizeObserver((entries) => {
          for (let entry of entries) {
            if (entry.contentRect.width <= mobileWidth) {
              this.componentTag = "mobileIndustry";
            } else {
              this.componentTag = "webBatteryIndustry";
            }
          }
        });
        resizeObserver.observe(document.body);
      },
    },
  };
  </script>